var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.73822d3fe4f7704835cb99db412597b0.svg#h';
                    var viewUrl = 'sprites.73822d3fe4f7704835cb99db412597b0.svg#view-h';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };